import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import Map from '../../../components/Map/index';
import MapMarker from '../../../components/MapMarker/index';
import * as actions from "../../../store/actions";
import getLocation from '../../../utils/getLocation'
import { i18n } from '../../../translate/i18n';

import {
  Container,
  Paper,
  Typography,
  IconButton,
  TextField,
  FormControl,
  RadioGroup,
  Radio,
  FormLabel,
  FormControlLabel
} from '@mui/material';

import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle
} from '../Forms/styles';

import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Business from '@mui/icons-material/Business';
import Room from '@mui/icons-material/Room';

import confirm from '../../../UI/Confirm/confirm';
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import Spinner from '../../../components/Spinner';


//props:
//type = root or branch or leaf
//edit = true or false
//parent = the parent node of the creating one (the actual node you clicked)

const ModalPlaces = (props) => {
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");

  const [editMode, setEditMode] = useState(false);

  const [name, setName] = useState("")
  const [childLabel, setChildLabel] = useState("")
  const [path, setPath] = useState("")
  const [pathOnEdit, setPathOnEdit] = useState("")
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [mapCenter, setMapCenter] = useState({});
  const [mapRef, setMapRef] = useState();

  const [type, setType] = useState('branch')

  const [selectedSites, setSelectedSites] = useState({});
  const [sitesFormated, setSitesFormated] = useState([])
  const [searchTextSites, setSearchTextSites] = useState("")
  const [sitesError, setSitesError] = useState(false);

  const fetchSites = useCallback(
    () => dispatch(actions.fetchSites(page, limit, searchTextSites, order, orderBy)),
    [page, limit, searchTextSites, order, orderBy]
  );

  const loadingSites = useSelector(state => state.sites.loading);
  const sites = useSelector(state => state.sites.sites);
  const places = useSelector(state => state.places.places)

  const [nameError, setNameError] = useState(false);
  const [childLabelError, setChildLabelError] = useState(false);

  //FUNCTION TO FORMAT TYPES IN THE AUTOCOMPLETE
  useEffect(() => {
    const dataFromRedux = sites
    let returnArray = []
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setSitesFormated(returnArray)
  }, [sites])

  useEffect(() => {
    fetchSites(page, limit, searchTextSites, order, orderBy);
  }, [searchTextSites]);

  useEffect(() => {
    if (!isEmpty(props.parent) && !props.edit) {
      setPath(props.parent.path + '/' + name)
    } else if (!isEmpty(props.parent) && props.edit) {
      setPath(pathOnEdit + '/' + name)
    } else {
      setPath('/' + name)
    }
  }, [name])

  useEffect(() => {
    if (props.edit) {
      let pathArray = props.parent.path.split('/');
      pathArray.pop();
      const correctPath = pathArray.join('/')
      setPathOnEdit(correctPath);

      setName(props.parent.name)
      setChildLabel(props.parent.childLabel)
      setType(props.parent.type)
      setLatitude(props.parent.latitude)
      setLongitude(props.parent.longitude)
      setMapCenter({ lat: props.parent.latitude, lng: props.parent.longitude })
      console.log('props from modal places: ', props);

      if (props.type === 'leaf' && (!props.parent.latitude || !props.parent.longitude)) {
        const thisRoot = places.rows.find((place) => place.site === props.parent.site && place.isRoot);
        console.log('this root from leaf: ', thisRoot);
        if (thisRoot && thisRoot.latitude && thisRoot.longitude) {
          setMapCenter({ lat: thisRoot.latitude, lng: thisRoot.longitude });
        } else {
          getLocation(locationSuccess)
        } 
      }

      if (props.type === 'root') {
        setSelectedSites({ value: props.parent.site._id, label: props.parent.site.name })
      }
    } else {
      setName("")
      setChildLabel("")
      setType('branch')
    }
  }, [])


  //post to BE
  const postPlaces = (body) => dispatch(actions.postPlaces(body))
  const updatePlaces = (index, body) => dispatch(actions.updatePlaces(index, body))
  const checkDeletePlaces = (index) => dispatch(actions.checkDeletePlaces(index))
  const deletePlaces = (index) => dispatch(actions.deletePlaces(index))

  const loadingPlaces = useSelector(state => state.places.loading);

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false
    if (!name) {
      setNameError(true)
      hasError = true
    }

    if (type === 'branch' && !childLabel) {
      setChildLabelError(true)
      hasError = true
    }

    if (hasError) return;

    let parent = ''
    if (props.edit) {
      parent = props.parent.parent ? props.parent.parent : ''
    } else {
      parent = !isEmpty(props.parent) ? props.parent._id : ''
    }

    const body = {
      name: name,
      path: path,
      type: type,
      childLabel: childLabel,
      isRoot: props.type === 'root',
      latitude,
      longitude,
    };

    if (parent) body['parent'] = parent

    if (props.type === 'root') body['site'] = selectedSites.value


    if (props.edit) {
      updatePlaces(props.parent._id, body).then((res) => {
        if (res === 'success') {
          props.closeModal(false, '')
        }
      })
    } else {
      postPlaces(body).then((res) => {
        if (res === 'success') {
          props.closeModal(false, '')
        }
      })
    }

  }

  const handleDeletePlace = (id) => {
    checkDeletePlaces(id).then(res => {
      if (res != 'error') {
        const objType = Object.keys(res)[0];
        if (res[objType] > 0) {

          confirm(`${i18n.t('handleDeletePlaceModalPlaces.confirmTrue')} ${res[objType]} ${objType === 'equipments' ? i18n.t('handleDeletePlaceModalPlaces.true') : i18n.t('handleDeletePlaceModalPlaces.false')}, ${i18n.t('handleDeletePlaceModalPlaces.text')}`,
            {
              title: i18n.t('handleDeletePlaceModalPlaces.titleTrue'),
              titleColor: 'red',
              disableBackdrop: true
            }).then(
              () => { },
              async () => { },
            )
        } else {
          confirm(i18n.t('handleDeletePlaceModalPlaces.confirmFalse'),
            {
              title: i18n.t('handleDeletePlaceModalPlaces.titleFalse'),
              titleColor: 'red',
              disableBackdrop: true
            }).then(
              () => { },
              async () => {
                deletePlaces(id);
                props.closeModal(false, '')
              },
            )
        }
      }
    })
  }

  const handleClick = (event) => {
    setLatitude(event.latLng.lat());
    setLongitude(event.latLng.lng());
  }

  const handleMapCenter = () => {
    setMapCenter({ lat: mapRef.center.lat(), lng: mapRef.center.lng() })
  }

  const handleDrag = (event) => {
    setLatitude(event.latLng.lat());
    setLongitude(event.latLng.lng());
  }

  const locationSuccess = (location) => {
    const lat = location.coords.latitude;
    const lng = location.coords.longitude;
  
    setMapCenter({ lat, lng });
  }

  
  const styles = {
    opacityContainer: {
      opacity: loadingPlaces ? '0.3' : '1',
      position: 'relative'
    },
    optionLabelContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    optionIcon: {
      paddingRight: 5,
    }
  }

  const handleInputChangeSelectorSites = (text) => {
    setSearchTextSites(text);
  }

  const handleInputChangeSites = selected => {
    setSitesError(false);
    setSelectedSites(selected)
  }

  return (
    <Container maxWidth='sm'>
      <Paper style={{maxHeight: '80vh', overflowY: 'auto'}}>
        <FormStyled onSubmit={handleSubmit} style={styles.opacityContainer}>
          {loadingPlaces && <Spinner overlay />}
          <DivFormTitle>
            <Typography variant='h6'>{props.edit ? i18n.t('typographyModalPlaces.true') : i18n.t('typographyModalPlaces.false')}{props.type === 'root' ? i18n.t('typographyModalPlaces.text') : props.parent.childLabel}</Typography>
            {props.edit &&
              <DivSubmitButtons>
                {editMode ?
                  <>
                    <IconButton onClick={() => props.closeModal(false, '')} size="large"><CloseIcon color='error' /></IconButton>
                    <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
                  </> :
                  <>
                    <IconButton onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
                    <IconButton onClick={() => handleDeletePlace(props.parent._id)} size="large"><DeleteIcon /></IconButton>
                  </>
                }
              </DivSubmitButtons>
            }
          </DivFormTitle>

          {(props.type === 'root' && !props.edit) &&
          <FormControl variant="standard" fullWidth margin='normal'>
            <Autocomplete
            loading={loadingSites} //sent to isLoading
            label={i18n.t('autocompleteModalPlace.site')}
            data={sitesFormated} // sent to options
            onSelectValue={handleInputChangeSites} // sent to onChange
            valueSelected={selectedSites} // sent to value
            newSearchText={handleInputChangeSelectorSites}
            name='site'
            hasError={sitesError}
            disabled={props.edit && !editMode}
            />
        </FormControl> }

        {(props.type !== 'root') &&
          <FormControl variant="standard" component="fieldset" margin='normal'>
            <FormLabel component="legend">Tipo</FormLabel>
            <RadioGroup
              aria-label="type"
              name="type"
              value={type}
              onChange={event => { setChildLabelError(false); return setType(event.target.value) }}
              margin='normal'
            >
              <FormControlLabel value="branch" control={<Radio disabled={props.type === 'root' || props.edit} />} label={<div style={styles.optionLabelContainer}><Business style={styles.optionIcon} />{i18n.t('formControlLabelModalPlace.business')}</div>} />
              <FormControlLabel value="leaf" control={<Radio disabled={props.type === 'root' || props.edit} />} label={<div style={styles.optionLabelContainer}><Room style={styles.optionIcon} />{i18n.t('formControlLabelModalPlace.room')}</div>} />
            </RadioGroup>
          </FormControl>}

          <FormControl variant="standard" fullWidth>
            <TextField
              variant="standard"
              autoFocus
              disabled={props.edit && !editMode}
              label={i18n.t('textFieldModalPlaces.name')}
              name='name'
              onChange={event => { setNameError(false); return setName(event.target.value.replace(/[/]/gi, "")); }}
              value={name}
              error={nameError}
              margin='normal'
              helperText={path} />
          </FormControl>
          {type !== 'leaf' && <FormControl variant="standard" fullWidth>
            <TextField
              variant="standard"
              disabled={(props.edit && !editMode) || type === 'leaf'}
              label={i18n.t('textFieldModalPlaces.childLabel')}
              name='childLabel'
              onChange={event => { setChildLabelError(false); return setChildLabel(event.target.value) }}
              value={childLabel}
              error={childLabelError}
              margin='normal'
              helperText={i18n.t('textFieldModalPlaces.helperText')} />
          </FormControl>}
          {(props.type === 'leaf' || props.type === 'root') && <FormControl variant="standard" fullWidth>
            <TextField
              variant="standard"
              autoFocus
              disabled={props.edit && !editMode}
              label={i18n.t('textFieldModalPlaces.latitude')}
              name='latitude'
              value={latitude}
              onChange={event => setLatitude(event.target.value) }
              margin='normal' />
          </FormControl>}
          {(props.type === 'leaf' || props.type === 'root') && <FormControl variant="standard" fullWidth>
            <TextField
              variant="standard"
              autoFocus
              disabled={props.edit && !editMode}
              label={i18n.t('textFieldModalPlaces.longitude')}
              name='longitude'
              value={longitude}
              onChange={event => setLongitude(event.target.value) }
              margin='normal' />
          </FormControl>}
          {(props.type === 'leaf' || props.type === 'root') && editMode &&
            <Map
              center={mapCenter}
              onClick={(e) => handleClick(e)}
              onLoad={map => setMapRef(map)}
              onDragEnd={() => handleMapCenter()}
              items={[<MapMarker
                key="marker"
                draggable
                handleDrag={(e) => handleDrag(e)}
                title={`${props.type}: ${name}`}
                latitude={latitude}
                longitude={longitude}  
              />]}
            />}
          {!props.edit &&
            <DivSubmitButtons>
              <IconButton onClick={() => props.closeModal(false, '')} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
              <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
            </DivSubmitButtons>
          }
        </FormStyled>
      </Paper>
    </Container>
  );
}

export default ModalPlaces;
